<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <mat-card>
        <div class="row message">
          <div class="col-12 text-center">
            <div *ngIf="errorCode === null">
              <h2>{{ 'HTTP.ERRORS.SIGNED.TITLE' | translate }}</h2>
              <h4>{{ errorMessage }}</h4>
            </div>

            <div *ngIf="errorCode === 0">
              <h2>{{ errorMessage }}</h2>
            </div>

            <h4>
              {{ 'HTTP.ERRORS.SIGNED.INVITATION' | translate }}
              <a [href]="link">{{
                'HTTP.ERRORS.SIGNED.COMPANY' | translate
              }}</a>
            </h4>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
